import { capabilities } from '../data/capabilities';
import gearIcon from '../assets/icons/gear.svg';
import './Capabilities.scss';

function Capabilities() {
  return (
    <section id="capabilities" className="capabilities">
      <div className="container">
        <span className="section-eyebrow">Capabilities</span>
        <h2 className="section-title">Engineering, fabrication, and electronics under one roof</h2>
        <div className="card-grid capabilities__grid">
          {capabilities.map((category) => (
            <article key={category.name} className="card capabilities__card">
              <h3>{category.name}</h3>
              <ul>
                {category.items.map((item) => (
                  <li key={item} className="capabilities__item">
                    <img className="capabilities__icon" src={gearIcon} alt="" aria-hidden="true" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Capabilities;
